// Top-level routes. Pack interior + practice + coloring routes get added in
// later steps; Step 3 only ships the auth flow.

import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from './auth/RequireAuth.tsx'
import { ColoringPage } from './pages/ColoringPage.tsx'
import { ColoringPlayground } from './pages/ColoringPlayground.tsx'
import { HomePage } from './pages/HomePage.tsx'
import { InventoryPage } from './pages/InventoryPage.tsx'
import { ItemDetailPage } from './pages/ItemDetailPage.tsx'
import { KEntryPage } from './pages/KEntryPage.tsx'
import { LoginPage } from './pages/LoginPage.tsx'
import { PackHomePage } from './pages/PackHomePage.tsx'
import { PracticePage } from './pages/PracticePage.tsx'
import { WelcomePage } from './pages/WelcomePage.tsx'

export function App() {
  return (
    <Routes>
      <Route path="/k/:token" element={<KEntryPage />} />
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <HomePage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId"
        element={
          <RequireAuth>
            <PackHomePage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId/practice"
        element={
          <RequireAuth>
            <PracticePage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId/inventory"
        element={
          <RequireAuth>
            <InventoryPage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId/item/:itemId"
        element={
          <RequireAuth>
            <ItemDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId/color/:itemId"
        element={
          <RequireAuth>
            <ColoringPage />
          </RequireAuth>
        }
      />
      <Route
        path="/pack/:packId/bonus"
        element={
          <RequireAuth>
            <ColoringPage />
          </RequireAuth>
        }
      />
      <Route path="/dev/coloring" element={<ColoringPlayground />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

function NotFoundPage() {
  return (
    <main className="mx-auto max-w-md p-8 text-center text-[var(--color-muted)]">
      <p className="text-2xl text-[var(--color-fg)]">這頁不存在</p>
      <a href="/" className="mt-4 inline-block underline">
        回主頁
      </a>
    </main>
  )
}
